import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String }

  open(event) {
    event.preventDefault()
    window.dispatchEvent(
      new CustomEvent('video-modal:open', {
        detail: { url: this.urlValue }
      })
    )
  }
}
